@switch (mimeType) {
  @case ('image/jpeg') {
    <img
      loading="lazy"
      src="https://media.sharry.land/app/images/ic-jpg.webp"
      alt="jpeg" />
  }
  @case ('image/jpg') {
    <img
      loading="lazy"
      src="https://media.sharry.land/app/images/ic-jpg.webp"
      alt="jpeg" />
  }
  @case ('image/png') {
    <img
      loading="lazy"
      src="https://media.sharry.land/app/images/ic-png.webp"
      alt="png" />
  }
  @case ('application/vnd.google-earth.kml+xml') {
    <img
      loading="lazy"
      src="https://media.sharry.land/app/images/ic-kml.webp"
      alt="kml" />
  }
  @case ('application/vnd.google-earth.xml') {
    <img
      loading="lazy"
      src="https://media.sharry.land/app/images/ic-kml.webp"
      alt="kml" />
  }
  @case ('application/gpx') {
    <img
      loading="lazy"
      src="https://media.sharry.land/app/images/ic-gpx.webp"
      alt="gpx-xml" />
  }
  @case ('application/xml') {
    <img
      loading="lazy"
      src="https://media.sharry.land/app/images/ic-gpx.webp"
      alt="gpx-xml" />
  }
  @case ('application/vnd.google-earth.kmz') {
    <img
      loading="lazy"
      src="https://media.sharry.land/app/images/ic-kml.webp"
      alt="kmz" />
  }
  @case ('application/pdf') {
    <img
      loading="lazy"
      src="https://media.sharry.land/app/images/ic-pdf.webp"
      alt="pdf" />
  }
}
